<template>
    <LottoBetSlip
        v-if="isLotto"
        class="betslip-preview"
        @close="$emit('close')"
    />
    <BetSlip
        v-else
        class="betslip-preview"
        v-bind="modalData"
        @close="$emit('close')"
    />
</template>

<script>
    import { isEmpty as _isEmpty } from '@lodash';
    import { mapGetters } from 'vuex';
    import BetSlip from '@shared/betSlip/BetSlip';
    import LottoBetSlip from '@app/modules/lotto/lottoBetSlip/LottoBetSlipContainer';
    import StoreUtil from '@app/store/StoreUtil';

    export default {
        name: 'BetSlipPreviewModal',
        computed: {
            ...mapGetters('ui/modal', [
                'modalData'
            ]),
            ...StoreUtil.mapGettersDynamic('modalData.betSlipNamespace', [
                'errors',
                'selectionErrors',
            ]),
            ...mapGetters('data/tickets', [
                'isTicketSubmitting',
                'submitErrors',
            ]),
            isLotto() {
                return this.modalData.type === 'lotto';
            }
        },
        watch: {
            isTicketSubmitting(newValue) {
                if (!newValue
                    && _isEmpty(this.submitErrors)
                    && _isEmpty(this.errors)
                    && _isEmpty(this.selectionErrors)) {
                    this.$emit('close');
                }
            }
        },
        components: {
            BetSlip,
            LottoBetSlip,
        }
    };
</script>


// WEBPACK FOOTER //
// src/app/modals/modals/betSlipPreview/BetSlipPreviewModal.vue